import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'jb-list-template-skeleton',
  templateUrl: './list-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListSkeletonComponent {}
